import DataTable from 'components/ui/DataTable/data-table';
import 'css/style.css';
import React, { FC, useContext, useState } from 'react';
import { IAttendanceInput, useListAttendanceQuery, useListAutoAttendanceQuery } from 'redux/reducers/attendance';
import { useListAdminUsersQuery } from 'redux/reducers/user';
import EditIcon from '../../../assets/images/icons/edit.png';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import { nascsubdomain } from 'redux/reducers/settings';
import moment from 'moment';
interface ITraineeDataTable {
  tableHeaders: () => React.ReactNode;
  onEditClicked: (data: IAttendanceInput) => void;
  onDeleteClicked: (data: IAttendanceInput) => void;
  // endDate: moment.Moment;
  selectedTraining: number;
  selectedSession: number;
  startDate: moment.Moment;
  endDate: moment.Moment;
}
const AttendanceTable: FC<ITraineeDataTable> = ({
  tableHeaders,
  onEditClicked,
  onDeleteClicked,
  selectedTraining,
  selectedSession,
  startDate,
  endDate
}) => {
  // const start_date = startDate.format('YYYY-MM-DD');
  // const end_date = endDate.isSame(startDate) ? '' : endDate.format('YYYY-MM-DD');
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState<string>('');
  const [pageSize, setPageSize] = useState(10);
  const offset = (page - 1) * pageSize;
  const { appConfig } = useContext(ConfigurationContext)

  // end_date,
  const start_date = startDate.isSame(endDate) ? '' : startDate.format('YYYY-MM-DD');
  const end_date = endDate.isSame(startDate) ? '' : endDate.format('YYYY-MM-DD');


  const { data: attendanceAutoData, isLoading: isLoadingAuto } = useListAutoAttendanceQuery({
    page: page,
    pageSize: pageSize,
    routineId: selectedTraining,
    date: start_date,
    end_date,
    query
  });
  const totalRows = attendanceAutoData?.data && attendanceAutoData?.data.length > 0 ? attendanceAutoData?.data?.[0].row_total : 0;

  // const totalPages = Math.ceil(totalRows / 10);
  // const canNext = pageNo < totalPages;
  // const canPrevious = pageNo > 1;

  const attendanceData = attendanceAutoData?.data
  const totalPages = Math.ceil(totalRows / 10);
  const canNext = page < totalPages;
  const canPrevious = page > 1;
  console.log(attendanceAutoData, canNext);

  const columns = [
    {
      Header: 'S.N',
      accessor: 'sn',
      Cell: (data: any) => {
        return <>{data.row.index + (page - 1) * 10 + 1}</>;
      }
    },
    {
      Header: 'Routine Name',
      accessor: (row: any) => {
        return `${row?.routine_details?.training_name} ${row?.routine_details?.batch_name}`;
      }
    },
    {
      Header: 'User',
      accessor: (row: any) => `${row?.user_details?.first_name} ${row?.user_details?.last_name}`
    },
    {
      Header: 'Phone',

      accessor: (row: any) => `${row?.user_details?.mobile_number}`

    },
    {
      Header: 'Attendance Type',
      accessor: 'source'

    },

    {
      Header: 'Approved By',
      accessor: 'approver_name'

    },
    {
      Header: 'Attendance Date',
      Cell: (data: any) => {
        return (
          <>{data.row.original.approved_date ? moment(data.row.original.approved_date).format('YYYY-MM-DD') : 'none'}</>
        );
      }
    },
    {
      Header: '  Status',
      accessor: 'status',
      Cell: (data: any) => {
        return (
          <>
            {data.row.original.status == 1 ? (
              <span className="p-1 rounded" style={{ color: 'white', backgroundColor: 'green' }}>
                Present
              </span>
            ) : (
              <span className="p-1 rounded" style={{ color: 'white', backgroundColor: 'red' }}>
                Absent
              </span>
            )}
          </>
        );
      }
    },
    {
      Header: '  Action',
      Cell: (data: any) => {
        return (
          <>
            <div
              className="border p-1 bg-primary text-white rounded text-center courser-pointer"
              onClick={() => onEditClicked(data.row.original)}>
              {data.row.original?.status == 0 ? 'Mark Present' : 'Mark Absent'}
            </div>
          </>
        );
      }
    }
  ];


  return (
    <div>
      <DataTable
        columns={columns}
        passedQuery={(e: string) => {
          setQuery(e);
        }}
        data={attendanceData || []}
        tableHeaders={tableHeaders}
        isLoading={isLoadingAuto}
        pagination={{
          canNext,
          canPrevious,
          prevPage: () => {
            if (canPrevious) {
              setPage((prev) => prev - 1);

            }
          },
          nextPage: () => {
            if (canNext) {
              setPage((prev) => prev + 1);
            }
          }
        }}
      />
    </div>
  );
};

export default AttendanceTable;
